export var Name = 'video-play';
export var UserAction = Name;